import { useDocumentsContext } from '../providers/DocumentsProvider';

export const useDocuments = () => {
  return useDocumentsContext();
};
